import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-modal-header',
  templateUrl: './modal-header.component.html',
  styleUrls: ['./modal-header.component.scss'],
})
export class ModalHeaderComponent  implements OnInit {
@Input() modalTitle: string;
@Output() dismissModal = new EventEmitter();
  constructor() { }

  ngOnInit() {}


  closeModal() {
    this.dismissModal.emit();
  }
}
